import { AbstractControl } from '@angular/forms';

export function ageValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const currentDate = new Date();
  if (control.value !== null && (isNaN(control.value) || control.value > currentDate)) {
    return { ageValidator: false };
  }
  return null;
}
